export const locales = ['lv', 'en'];
export const defaultLocale = 'lv';
